//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ProductCard from "@/components/catalog/ProductCard";
import UiLazyImg from "@/components/Ui/UiLazyImg.vue";

export default {
  name: "Products",
  components: {
    Swiper,
    SwiperSlide,
    ProductCard,
    UiLazyImg
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    requestedProducts: {
      type: Array,
      default() {
        return []
      }
    },
    requestedCollection: {
      type: String,
      default: ''
    }
  },
  async fetch() {
    await this.getProducts();
  },
  data() {
    return {
      productsLoading: false,
      productList: [],
      swiperOption: {
        mousewheel: {
          forceToAxis: true
        },
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        navigation: {
          nextEl: '.pdp-swiper-custom-button-next',
          prevEl: '.pdp-swiper-custom-button-prev'
        },
        breakpoints: {
          1800: {
            slidesPerView: 3.8,
          },
          1500: {
            slidesPerView: 3.76,
          },
          1300: {
            slidesPerView: 3.7,
          },
          1100: {
            slidesPerView: 2.75,
          },
          920: {
            slidesPerView: 2.7,
          },
          600: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          }
        }
      }
    }
  },
  methods: {
    async getProducts() {
      this.productsLoading = true;
      const params = {};
      if (this.requestedCollection) {
        params.collection_slug = this.requestedCollection;
      }
      if (this.requestedProducts?.length) {
        params.configurations_ids = this.requestedProducts;
      }
      try {
        const { data } = await this.$axios.get('/showcase/plp', {params});
        this.productList = data?.data?.products;
      } catch (err) {
        console.log('error', err);
      }
      this.productsLoading = false;
    },
  }
}
